import {
  convertNumber,
  GeckoMeasurementJson,
  GeckoMeasurementSystem,
  GeckoMeasurementUnit,
  lookUpPreferredUnit,
} from 'types'

import { ScopeType } from './techniqueTypes'

export const scopeBaseUnit = (scopeType: ScopeType) =>
  ({
    area: GeckoMeasurementUnit.SquareMeters,
    length: GeckoMeasurementUnit.Meters,
    count: GeckoMeasurementUnit.None,
  })[scopeType]

export const scopeDisplayUnit = (
  scopeType: ScopeType,
  system: GeckoMeasurementSystem
) => lookUpPreferredUnit(scopeBaseUnit(scopeType), system)

export function isScopeCompatible(
  scope: GeckoMeasurementJson,
  scopeType: ScopeType
) {
  const units = {
    area: [
      GeckoMeasurementUnit.SquareMeters.id,
      GeckoMeasurementUnit.SquareFeet.id,
    ],
    length: [
      GeckoMeasurementUnit.Meters.id,
      GeckoMeasurementUnit.Feet.id,
      GeckoMeasurementUnit.Millimeters.id,
      GeckoMeasurementUnit.Inches.id,
    ],
    count: [GeckoMeasurementUnit.None.id],
  }
  return (
    Number.isFinite(scope.num) &&
    scope.num >= 0 &&
    units[scopeType].includes(scope.unit) &&
    (scopeType !== 'count' || Number.isInteger(scope.num))
  )
}

export function scopeInUnit(
  scope: GeckoMeasurementJson | undefined,
  scopeType: ScopeType,
  unit: GeckoMeasurementUnit
) {
  if (!scope || !isScopeCompatible(scope, scopeType)) return undefined
  return convertNumber(
    scope.num,
    GeckoMeasurementUnit.GetOrCreate(scope.unit),
    unit
  )
}

export function formatScope(
  scope: GeckoMeasurementJson | undefined,
  scopeType: ScopeType,
  system: GeckoMeasurementSystem,
  countLabel = 'count'
) {
  if (!scope) return 'Not specified'
  const unit = scopeDisplayUnit(scopeType, system)
  const value = scopeInUnit(scope, scopeType, unit)
  if (value === undefined) return 'Incompatible units'
  return `${value.toLocaleString('en-GB', { maximumFractionDigits: 3 })} ${scopeType === 'count' ? countLabel : unit.name}`
}
